export default __webpack_public_path__ + "static/media/968f06eb980a4748649a35b6701af842.svg";